// js/core/Input.js
// 指標輸入控制器：統一滑鼠／觸控／筆（Pointer Events）。
// 將客戶端座標交給 Game 提供的 toWorld 轉成世界格座標，並以回呼通知繪圖狀態。

export class Input {
  constructor(canvas, { toWorld, onDrawStart, onPoint, onDrawEnd } = {}) {
    this.canvas = canvas;
    this.toWorld = toWorld;
    this.onDrawStart = onDrawStart;
    this.onPoint = onPoint;
    this.onDrawEnd = onDrawEnd;
    this.active = false;
    this._handlers = null;
  }

  attach() {
    if (this._handlers) return;
    const down = (e) => this._down(e);
    const move = (e) => this._move(e);
    const up = (e) => this._up(e);
    this._handlers = { down, move, up };
    this.canvas.addEventListener('pointerdown', down);
    this.canvas.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  }

  detach() {
    if (!this._handlers) return;
    const { down, move, up } = this._handlers;
    this.canvas.removeEventListener('pointerdown', down);
    this.canvas.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', up);
    window.removeEventListener('pointercancel', up);
    this._handlers = null;
    this.active = false;
  }

  _world(e) {
    const rect = this.canvas.getBoundingClientRect();
    return this.toWorld(e.clientX - rect.left, e.clientY - rect.top);
  }

  _down(e) {
    this.active = true;
    try { this.canvas.setPointerCapture(e.pointerId); } catch (_) { /* ignore */ }
    if (this.onDrawStart) this.onDrawStart();
    if (this.onPoint) this.onPoint(this._world(e));
  }

  _move(e) {
    if (!this.active) return;
    if (this.onPoint) this.onPoint(this._world(e));
  }

  _up(e) {
    if (!this.active) return;
    this.active = false;
    if (this.onDrawEnd) this.onDrawEnd();
  }
}
